/* Petifo · lightbox: close button, video activation, video thumbnail badge,
   carousel watchdog. Loaded AFTER assets/pf-zoom-extras.js.

   ONE OWNER PER PROPERTY. This file deliberately does NOT size or position the
   video — assets/pf-zoom-video.js owns that, alone. An earlier version sized it
   here too, on a 500ms watchdog, while pf-zoom-video.js sized it to the image
   box on a 600ms timer. The two overwrote each other forever and the video
   visibly pumped between 1512px and 1361px (Peji: "videon blir stor och liten
   hela tiden"), and the constant relayout also ate the first click on the main
   gallery, so the lightbox needed two taps to open. If you ever need to change
   the video's geometry, change it in pf-zoom-video.js — never add a second
   writer here.

   1. CLOSE BUTTON — THE THEME BLENDS IT, IT DOES NOT COLOUR IT.
   `.close-button` carries `mix-blend-mode: difference` so a bare glyph stays
   legible over any photo. That INVERTS whatever you paint: a brand-green disc
   rendered PINK against the cream backdrop while getComputedStyle still said
   rgb(6,77,69). ALWAYS check mix-blend-mode before treating a colour bug as a
   specificity bug. Kill the blend first, then colour.

   2. NO BROWSER CHROME. Setting `controls` gives the whole browser player —
   scrubber, timecode, volume, fullscreen, overflow menu — which reads as an
   embedded video rather than a product shot. controls stay OFF; the single
   play/pause overlay lives in pf-zoom-video.js and is exempted from the button
   hide below via :not(.pf-zx-play).

   3. VIDEO ACTIVATION — ON OPEN, NOT ON SCROLL. Shopify's generated poster
   (thumbnail.0000000000.jpg) returns complete:false / naturalWidth:0 here, so
   the slide renders as an empty box and reads as "the video is missing". An
   earlier attempt activated only the CURRENT slide from the gallery's scroll
   listener and the marker attribute was never even set — that trigger did not
   fire reliably. `deferred-media.loadContent(false)` is the supported API.

   4. VIDEO THUMBNAILS get a play badge; the thumbnail INDEX matches the slide
   index, which is how the video ones are found.

   5. CAROUSEL WATCHDOG — KEEP IT. The zoom layer suspends the carousel while an
   image is zoomed (inline overflow:hidden / touch-action:none /
   scroll-snap-type:none — inline because a stylesheet !important rule loses on
   this theme). If that state is ever stranded — a finger lifted over the video,
   a cancelled gesture — the gallery is both unscrollable and unsnapped, parks
   between two slides showing half of each, and refuses to swipe. It only strips
   the lock and re-snaps; it does not touch the video. */
(function () {
  'use strict';

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var id = 'pf-zx-close-css';
  if (!document.getElementById(id)) {
    var css = ''
      + '.dialog-zoomed-gallery__dialog .dialog-zoomed-gallery__close-button{'
      + 'mix-blend-mode:normal!important;isolation:isolate!important;'
      + 'position:fixed!important;top:14px!important;right:14px!important;'
      + 'width:44px!important;height:44px!important;'
      + 'display:flex!important;align-items:center!important;justify-content:center!important;'
      + 'padding:0!important;border-radius:50%!important;'
      + 'background:#EFEFEC!important;color:#3A3A3A!important;'
      + 'border:1px solid rgba(0,0,0,.16)!important;'
      + 'box-shadow:0 2px 10px rgba(0,0,0,.18)!important;'
      + 'z-index:2147483000!important;cursor:pointer;transition:background .15s ease}'
      + '.dialog-zoomed-gallery__dialog .dialog-zoomed-gallery__close-button:hover{background:#E2E2DF!important}'
      + '.dialog-zoomed-gallery__dialog .dialog-zoomed-gallery__close-button svg{'
      + 'mix-blend-mode:normal!important;width:17px!important;height:17px!important;'
      + 'color:#3A3A3A!important;stroke:#3A3A3A!important;fill:none!important;stroke-width:2!important}'
      + '@media (max-width:749px){.dialog-zoomed-gallery__dialog .dialog-zoomed-gallery__close-button{'
      + 'top:10px!important;right:10px!important;width:42px!important;height:42px!important}}'
      /* transparent, no frame — sizing belongs to pf-zoom-video.js */
      + '.dialog-zoomed-gallery .product-media-container--video,'
      + '.dialog-zoomed-gallery .product-media-container--video .product-media,'
      + '.dialog-zoomed-gallery .product-media-container--video deferred-media,'
      + '.dialog-zoomed-gallery .product-media-container--video video{'
      + 'background:transparent!important;border:0!important;outline:0!important;box-shadow:none!important}'
      /* hide the theme leftovers, never our own toggle */
      + '.dialog-zoomed-gallery .product-media-container--video .deferred-media__poster,'
      + '.dialog-zoomed-gallery .product-media-container--video button:not(.pf-zx-play){display:none!important}'
      + '.dialog-zoomed-gallery .product-media-container--video video::-webkit-media-controls,'
      + '.dialog-zoomed-gallery .product-media-container--video video::-webkit-media-controls-enclosure,'
      + '.dialog-zoomed-gallery .product-media-container--video video::-webkit-media-controls-panel{'
      + 'display:none!important;opacity:0!important}'
      /* play badge on video thumbnails */
      + '.pf-zx-vthumb{position:relative!important}'
      + '.pf-zx-vthumb::after{content:"";position:absolute;top:50%;left:50%;width:24px;height:24px;'
      + 'margin:-12px 0 0 -12px;border-radius:50%;background:rgba(0,0,0,.55);'
      + 'box-shadow:0 0 0 1.5px rgba(255,255,255,.85);pointer-events:none;z-index:4}'
      + '.pf-zx-vthumb::before{content:"";position:absolute;top:50%;left:50%;'
      + 'margin:-5px 0 0 -2px;width:0;height:0;border-style:solid;border-width:5px 0 5px 8px;'
      + 'border-color:transparent transparent transparent #fff;pointer-events:none;z-index:5}';
    var st = document.createElement('style');
    st.id = id;
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  }

  function dialogEl() { return qs('.dialog-zoomed-gallery__dialog'); }
  function galleryEl() { var d = dialogEl(); return d ? qs('.dialog-zoomed-gallery', d) : null; }
  function isOpen() { var d = dialogEl(); return !!(d && d.hasAttribute('open')); }
  function videoSlides() { return qsa('.dialog-zoomed-gallery .product-media-container--video'); }

  /* ---------- no browser chrome ---------- */

  function stripChrome(slide) {
    var v = slide.querySelector('video');
    if (!v) return;
    try {
      v.removeAttribute('controls');
      v.controls = false;
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('loop', '');
      v.setAttribute('disablepictureinpicture', '');
      v.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
      if (v.paused) v.play().catch(function () {});
    } catch (e) {}
    /* never our own toggle */
    qsa('.deferred-media__poster, .deferred-media__poster-button, button:not(.pf-zx-play)', slide)
      .forEach(function (b) { b.style.setProperty('display', 'none', 'important'); });
    qsa('img', slide).forEach(function (im) {
      im.style.setProperty('display', 'none', 'important');
    });
  }

  /* ---------- thumbnails ---------- */

  function markVideoThumbs() {
    var d = dialogEl();
    if (!d) return;
    var slides = qsa('.dialog-zoomed-gallery .product-media-container', d);
    var thumbs = qsa('.dialog-thumbnails-list__thumbnail', d);
    if (!thumbs.length) return;
    slides.forEach(function (s, i) {
      if (String(s.className).indexOf('--video') === -1) return;
      var t = thumbs[i];
      if (!t || t.getAttribute('data-pf-vthumb') === '1') return;
      t.setAttribute('data-pf-vthumb', '1');
      t.classList.add('pf-zx-vthumb');
    });
  }

  /* ---------- activation ---------- */

  function activateAllVideos() {
    videoSlides().forEach(function (slide) {
      if (slide.getAttribute('data-pf-vid') === '1') return;
      var dm = slide.querySelector('deferred-media');
      if (!dm) return;
      slide.setAttribute('data-pf-vid', '1');
      try {
        if (typeof dm.loadContent === 'function') dm.loadContent(false);
        else {
          var b = dm.querySelector('button.deferred-media__poster-button, button');
          if (b) b.click();
        }
      } catch (e) {}
      [300, 900, 1800].forEach(function (ms) {
        setTimeout(function () { stripChrome(slide); }, ms);
      });
    });
  }

  /* ---------- carousel watchdog (never touches the video) ---------- */

  var lastScroll = 0;

  function bindScroll() {
    var g = galleryEl();
    if (!g || g.getAttribute('data-pf-wd') === '1') return;
    g.setAttribute('data-pf-wd', '1');
    g.addEventListener('scroll', function () { lastScroll = Date.now(); }, { passive: true });
  }

  function isReallyZoomed(g) {
    var t = qsa('img', g);
    for (var i = 0; i < t.length; i++) {
      var tr = t[i].style.transform || '';
      if (tr.indexOf('scale(') > -1 && tr.indexOf('scale(1)') === -1) return true;
    }
    return false;
  }

  function unstick() {
    if (!isOpen()) return;
    var g = galleryEl();
    if (!g) return;
    if (isReallyZoomed(g)) return;

    if (g.style.overflow || g.style.touchAction || g.style.scrollSnapType ||
        g.classList.contains('pf-zf--zoomed')) {
      g.style.removeProperty('overflow');
      g.style.removeProperty('touch-action');
      g.style.removeProperty('scroll-snap-type');
      g.classList.remove('pf-zf--zoomed');
    }

    if (Date.now() - lastScroll < 450) return;
    var w = g.clientWidth || 1;
    var off = g.scrollLeft % w;
    if (off > 2 && off < w - 2) {
      g.scrollLeft = Math.round(g.scrollLeft / w) * w;
    }
  }

  function onOpen() {
    setTimeout(activateAllVideos, 250);
    setTimeout(bindScroll, 100);
    [200, 800, 1600].forEach(function (ms) { setTimeout(markVideoThumbs, ms); });
  }

  function watch() {
    var d = dialogEl();
    if (!d || d.getAttribute('data-pf-vidwatch') === '1') return;
    d.setAttribute('data-pf-vidwatch', '1');
    try {
      new MutationObserver(function () {
        if (d.hasAttribute('open')) onOpen();
        else qsa('.dialog-zoomed-gallery video').forEach(function (v) { try { v.pause(); } catch (e) {} });
      }).observe(d, { attributes: true, attributeFilter: ['open'] });
    } catch (e) {}
    if (d.hasAttribute('open')) onOpen();
  }

  watch();
  setInterval(unstick, 500);
  var n = 0;
  var iv = setInterval(function () {
    watch();
    bindScroll();
    markVideoThumbs();
    if (++n > 40) clearInterval(iv);
  }, 500);
})();